const Styles = {
    'InlineControlGroup': 'InlineControlGroup_InlineControlGroup--d87d483d'
};

export default Styles;